import React from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { TextLinkListProps, BlogResourcesWrapper } from './TextLinkList';
import { Content } from '.generated/Feature.CW.model';
import { Data } from '.generated/Foundation.CW.model';

const BlogResources = (): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();

  // Extract blogTags from sitecoreContext
  const blogTags = sitecoreContext?.route?.fields?.blogTags as
    | Data.PageSpecific.BlogTag[]
    | undefined;
  // Get the first blogTag's resource field
  const firstBlogTagResource = blogTags?.[0]?.fields
    ?.resources as unknown as Content.TextLinkList_Component;
  // If no blogTags or resource data, return empty div
  if (!blogTags || !firstBlogTagResource) {
    return <></>;
  }

  const props = {
    ...firstBlogTagResource,
    isSidenavPart: false,
    fields: {
      heading: firstBlogTagResource.fields?.heading,
      column1: firstBlogTagResource.fields?.column1 as unknown as Content.LinkGroup_Component[],
      column2: firstBlogTagResource.fields?.column2 as unknown as Content.LinkGroup_Component[],
      column3: firstBlogTagResource.fields?.column3 as unknown as Content.LinkGroup_Component[],
    },
  } as TextLinkListProps;

  return <BlogResourcesWrapper {...props} />;
};

export default BlogResources;
